import PropTypes from "prop-types";
import React from "react";
import Polyline from "./Polyline";

/**
 * -Polylines-
 * Polylines component
 */
export default class Polylines extends React.Component {

    state = {
        polylines: []
    }

    updatePolylines = () => {

        let polylines;

        if (!Array.isArray(this.props.polylines)) {

            polylines = Object
                .keys(this.props.polylines || {})
                .map(
                    (key) =>
                        this.props.polylines[key]
                );

            polylines = [].concat(...polylines);

        } else {

            polylines = this.props.polylines;
        }

        polylines = polylines === undefined
            ? []
            : polylines;

        this.setState({
            polylines
        });
    }

    componentDidMount() {
        this.updatePolylines();
    }

    componentDidUpdate(prevProps) {

        if (this.props.polylines !== prevProps.polylines) {

            this.setState(
                {
                    polylines: []
                },
                () => {
                    this.updatePolylines();
                }
            );
        }
    }

    render() {

        const polylines = this.state.polylines.map(
            (polyline, i) => (
                <Polyline
                    polylines={
                        this.state.polylines
                    }
                    path={
                        polyline.path
                    }
                    strokeWeight={
                        polyline.strokeWeight
                    }
                    color={
                        polyline.color
                    }
                    onClick={
                        polyline.onClick
                    }
                    opacity={
                        polyline.opacity
                    }
                    onHover={
                        polyline.onHover
                    }
                    rideName={
                        polyline.rideName
                    }
                    onRoad={
                        polyline.onRoad
                    }
                    routeNo={
                        polyline.routeNo
                    }
                    zIndex={
                        polyline.zIndex
                    }
                    dismount={
                        polyline.walk
                    }
                    segmentType={
                        polyline.segmentType
                    }
                    surface={
                        polyline.surface
                    }
                    key={i}
                    {...this.props}
                />
            )
        );

        return (
            <div>
                {polylines}
            </div>
        );
    }
}

Polylines.propTypes = {
    polylines: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ])
};


// WEBPACK FOOTER //
// ./src/components/googlemaps/Polylines.js